import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import ReLoginModal from "../components/ReLoginModal";
import TopNav from "../layouts/TopNav";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { BiArrowBack } from "react-icons/bi";
import api from "../util/axios";

type Banks = {
  bankName: string;
  accountNumber: string;
  balance: string;
  bankCode: string;
};

const BankTable = () => {
  const navigate = useNavigate();
  const token = window.localStorage.getItem("token");
  const [reLogin, setReLogin] = useState(false);
  const [getbanks, setGetBanks] = useState<Banks[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  function querySetting() {
    setIsLoading(true);
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    return api
      .get("/settings", {
        headers: headers,
      })
      .then((res) => {
        setGetBanks(res.data.data.banks);
        setIsLoading(false);
      })
      .catch((error) => {
        if (
          error.response.data.message === "jwt expired" ||
          error.response.data.message === "jwt malformed"
        ) {

          setReLogin(true);
        } else {
          setReLogin(false);
        }
        toast.error(error.response.data.message);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    querySetting();
  }, []);

  return (
    <div className="board">
      <TopNav title="Registered Banks" />
      <ToastContainer />
      {reLogin ? <ReLoginModal /> : null}
      <div className="p-12">
        <button onClick={(() => navigate(-1))} className="flex items-center cursor-pointer bg-red-400 hover:bg-red-500 text-white gap-2 py-1 px-10 rounded-lg"><BiArrowBack /> Back</button>

        <div className="invoiceTable !mt-8">
          {isLoading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <CircularProgress />
              <h2>Please wait while we process the request...</h2>
            </div>
          ) : (
            <table className="inTable">
              <tr className="heTable">
                <th>Bank Name</th>
                <th>Account Number</th>
                <th>Balance</th>
                <th>Bank code</th>
              </tr>

              {getbanks.map((bank, inx) => {
                return (
                  <>
                    <tr key={inx} className="taData">
                      <td>{bank.bankName}</td>
                      <td>{bank.accountNumber}</td>
                      <td>{bank.balance}</td>
                      <td>{bank.bankCode}</td>
                    </tr>
                  </>
                );
              })}
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default BankTable;
